<template>
    <div class="container py-5">
        <div class="px-4 py-5 text-center text-light h-50">
            <h2 class="display-4 fw-bold">CV</h2>
            <div class="col-lg-6 mx-auto">
                <p class="lead mb-4">The current site has been put together using <code>Vue</code> components and some
                    frontend helpers provided by <code>bootstrap</code>. It showcases how vue components can be used to
                    put together a simple static responsive site.</p>
                <p>Vue 3 | NodeJS - NPM | Bootstrap 5</p>
                <div class="d-grid gap-2 d-sm-flex justify-content-sm-center mb-5">
                    <a href="https://saqibofficial.com"><button type="button"
                            class="btn btn-outline-secondary btn-lg px-4">CV</button></a>
                </div>
            </div>
            <div class="overflow-hidden">
                <div class="container px-5">
                    <a href="https://saqibofficial.com"><img src="../assets/img/cvthumbnail.png"
                            class="img-fluid border rounded-3 shadow-lg mb-4" alt="cv site" width="700" height="900"
                            loading="lazy"></a>
                </div>
            </div>
        </div>
    </div>
</template>